var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"footer"}},[_c('v-pagination',{attrs:{"length":_vm.totalPag,"total-visible":"6"},on:{"input":_vm.cambioPagina},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }